export const ALL_MAKES_PAGE = 'allMakesPage';
export const ALL_MAKES_PAGE_PATH = 'allMarke';
export const MAKE_PAGE = 'makePage';
export const MODEL_PAGE = 'modelPage';
export const VARIANT_PAGE = 'variantPage';
export const SEO_PATH = '/auto';
export const STAGING_ENVIRONMENT = 'staging';

export const CLP_URL = '/gebrauchtwagen';
